require("babel-polyfill")

if (!window.Buffer) {
    window.Buffer = require('buffer')
}

if (!window.Promise) {
    window.Promise = require('bluebird')
}

window.moment = require('moment')
window.momentRange = require('moment-range')

window.momentRange.extendMoment(window.moment)

const bridget = require('imports-loader?define=>false!jquery-bridget?')

// para expor o jQuery para todas as bibliotecas que não suportam CommonJS
const $ = window.jQuery = window.$ = require('jquery')

require('./libraries/jquery.uniform.js?this=>window')
require('./libraries/jquery.slimscroll.js?this=>window&define=>false')
require('./libraries/bootstrap.js?this=>window')
require('./libraries/bootstrap.touchspin.min.js?this=>window')
require('./libraries/bootstrap-hover-dropdown.js?this=>window')
require('./libraries/bootstrap-jasny.min.js?this=>window')
require('./libraries/select2.full.min.js?this=>window')
require('./libraries/jquery.inputmask.blundle.js?this=>window')
require('./libraries/datetimepicker.min.js?this=>window')
require('./libraries/detect-element-resize?this=>window')

require('fullcalendar')
require('fullcalendar/dist/locale/pt-br')
require('bootstrap-colorpicker')
require('bootstrap-daterangepicker')

require('./libraries/jquery.scrollto.min.js')
require('./libraries/bootstrap-maxlength.min.js')

require('./locale.js')

const R = require('ramda')

const Dropzone = require('dropzone')

Dropzone.autoDiscover = false

const Packery = require('packery')

Packery.prototype.getShiftPositions = function (attrName) {
    attrName = attrName || 'id'
    const _this = this
    return this.items.map(function (item) {
        return {
            attr: item.element.getAttribute(attrName),
            x: item.rect.x / _this.packer.width
        }
    })
}

Packery.prototype.initShiftLayout = function (positions, attr) {
    if (!positions) {
        // if no initial positions, run packery layout
        this.layout()
        return
    }
    // parse string to JSON
    if (typeof positions === 'string') {
        try {
            positions = JSON.parse(positions)
        } catch (error) {
            console.error('JSON parse error: ' + error)
            this.layout()
            return
        }
    }

    attr = attr || 'id' // default to id attribute
    this._resetLayout()
    // set item order and horizontal position from saved positions
    this.items = positions.map(function (itemPosition) {
        const selector = '[' + attr + '="' + itemPosition.attr + '"]'
        const itemElem = this.element.querySelector(selector)
        const item = this.getItem(itemElem)
        item.rect.x = itemPosition.x * this.packer.width
        return item
    }, this)
    this.shiftLayout()
}

bridget('packery', Packery, $)

window.dd = function (v) {
    console.info(JSON.stringify(v, null, ' '))
}

$.fn.modal.Constructor.prototype.enforceFocus = $.noop

$(function () {
    $(document).on('click', '.selectable-text', function () {
        if (document.selection) {
            const range = document.body.createTextRange()
            range.moveToElementText(this)
            range.select()
        } else if (window.getSelection) {
            const range = document.createRange()
            range.selectNode(this)
            window.getSelection().removeAllRanges()
            window.getSelection().addRange(range)
        }
    })
    //Arrumando select2
    $.fn.select2.amd.require(["select2/dropdown/attachBody", "select2/utils"], (AttachBody, Utils) => {
        AttachBody.prototype._attachPositioningHandler = function (decorated, container) {
            const self = this;
            const scrollEvent = "scroll.select2." + container.id;
            const resizeEvent = "resize.select2." + container.id;
            const orientationEvent = "orientationchange.select2." + container.id;
            const $watchers = this.$container.parents().filter(Utils.hasScroll);
            $watchers.each(function () {
                $(this).data("select2-scroll-position", {
                    x: $(this).scrollLeft(),
                    y: $(this).scrollTop()
                });
            });
            $watchers.on(scrollEvent, function (ev) {
                const position = $(this).data("select2-scroll-position");
                $(self).scrollTop(position.y); // patch: this => self
            });
            $(window).on(scrollEvent + " " + resizeEvent + " " + orientationEvent,
                function (e) {
                    self._positionDropdown();
                    self._resizeDropdown();
                }
            );
        };
    });
})

R.dot = R.pipe(R.split('.'), R.path)
R.mapIndexed = R.addIndex(R.map)

window.Vue = require('vue')
window.Bluebird = require('bluebird')


// WEBPACK FOOTER //
// ./resources/assets/javascript/vendor/index.js